import React, { useState } from "react";
import FormGroup from "./Bootstrap/FormGroup";
import AwardList from "./Form/Awards/AwardList";
import EducationList from "./Form/Education/EducationList";
import ExperienceList from "./Form/Experience/ExperienceList";
import InterestList from "./Form/Interests/InterestList";
import SkillsList from "./Form/Skills/SkillsList";
import ProjectList from "./Form/Project/ProjectList";
import LanguageList from "./Form/Language_/LanguageList";
import CertificationList from "./Form/Certification/CertificationList";
import "./Portfolio_Form.css";



// form field
const FIELD_DESCRIPTIONS = {
  Name: ["text", "Name", "Please enter your name.", "required"],
  FatherName: ["text", "Father's Name", "Please enter your father's name.", "required"],
  Thumbnail: ["file", "Your Photo", "Please upload your photo in a CDN (e.g., Imgur) and paste the direct image URL here.", "required"],
  Description: ["textarea", "About you", "Write something nice about you", "required"],
  Address: ["text", "Address", "Type in your full address", "required"],
  City: ["text", "City", "Please enter your city", "required"],
  State: ["text", "State", "Please enter your state", "required"],
  Country: ["text", "Country", "Please enter your country", "required"],
  Phone: ["text", "Phone Number", "Please enter your phone number", "required"],
  Email: ["text", "Email Address", "Tell us your primary email address", "required"],
};

const SOCIAL_MEDIA = {
  URL: ["text", "Personal Website link", "Please enter the URL of your website, where this page is going to be hosted", "required"],
  LinkedIn: ["text", "LinkedIn", "Please enter your LinkedIn profile URL"],
  Twitter: ["text", "Twitter", "Please enter your Twitter profile URL"],
  Facebook: ["text", "Facebook", "Please enter your Facebook profile URL"],
  Instagram: ["text", "Instagram", "Please enter your Instagram profile URL"],
};

// Buttons for navigation
const SECTION_BUTTONS = [
  { key: "basicInfo", label: "Basic Info" },
  { key: "education", label: "Education" },
  { key: "experience", label: "Experience" },
  { key: "projects", label: "Projects" },
  { key: "certifications", label: "Certifications" },
  { key: "skills", label: "Skills" },
  { key: "awards", label: "Awards" },
  { key: "interests", label: "Interests" }
];

const PortfolioForm = ({ FormData, onChange, onViewPortfolio }) => {
  const [activeSection, setActiveSection] = useState("basicInfo");
  const [error, setError] = useState([]);

  const handleSectionChange = (section) => {
    // validate the form if key education is clicked but basic info is not filled then show error
    setActiveSection(section);
    };

  const saveDetails = () => {
    let error = [];

    Object.keys(FormData).forEach((key) => {
      if (!FormData[key] && key !== 'URL' && key !== 'LinkedIn' && key !== 'Twitter' && key !== 'Facebook' && key !== 'Instagram') {
        error.push(key);
      }
    });

    console.log(error);

    if (error.length > 0) {
      setError(error);
    }
    else {
      setError([]);
     
    }

    let nextSectionIndex = SECTION_BUTTONS.findIndex((btn) => btn.key === activeSection) + 1;
    if (nextSectionIndex < SECTION_BUTTONS.length) {
      setActiveSection(SECTION_BUTTONS[nextSectionIndex].key);
    }
  }

  const renderBasicInfo = () => (
    <div className="basic-info-container">
      <div className="twiceWrapper">
        {Object.keys(FormData).map(
          (field) =>
            FIELD_DESCRIPTIONS[field] && (
              <FormGroup
                key={field}
                Label={FIELD_DESCRIPTIONS[field][1]}
                Type={FIELD_DESCRIPTIONS[field][0]}
                Id={field}
                Desc={FIELD_DESCRIPTIONS[field][2]}
                Value={FormData[field]}
                Placeholder={`Enter ${FIELD_DESCRIPTIONS[field][1]}`}
                onChange={onChange}
                Error={error.includes(field)}
              />
            )
        )}
      </div>
      <h3 style={{ marginTop: '10px' }}>Social Links</h3>
      <div className="twiceWrapper">
        {Object.keys(FormData).map(
          (field) =>
            SOCIAL_MEDIA[field] && (
              <FormGroup
                key={field}
                Label={SOCIAL_MEDIA[field][1]}
                Type={SOCIAL_MEDIA[field][0]}
                Id={field}
                Desc={SOCIAL_MEDIA[field][2]}
                Value={FormData[field]}
                Placeholder={`Enter ${SOCIAL_MEDIA[field][1]} Link`}
                onChange={onChange}
                Error={error.includes(field)}
              />
            )
        )}
      </div>

    </div>
  );

  const renderSectionContent = () => {
    switch (activeSection) {
      case "basicInfo":
        return renderBasicInfo();
      case "education":
        return <EducationList />;
      case "experience":
        return <ExperienceList />;
      case "projects":
        return <ProjectList />;
      case "certifications":
        return <CertificationList />;
      case "skills":
        return <SkillsList />;
      case "awards":
        return <AwardList />;
      case "interests":
        return <InterestList />;
      case "languages":
        return <LanguageList />;
      default:
        return null;
    }
  };

  return (
    <div className="FormWrapper">
      <div className="button-row">
        <ol>
          {SECTION_BUTTONS.map(({ key, label }) => (
            <li
              key={key}
              className={`toggle-button ${activeSection === key ? "activeTab completed" : ""}`}
            >
              <div onClick={() => handleSectionChange(key)}>
                <i>{SECTION_BUTTONS.findIndex((btn) => btn.key === key) + 1}</i>
              </div>
              <div style={{ fontSize: '14px' }}>{label}</div>
            </li>
          ))}
        </ol>
      </div>

      <div className="content-container" style={{marginBottom:'15px'}}>
        {/* title of section */}
        <div className="section-title flex" style={{ justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #ccc', paddingBottom: '10px', marginBottom: '15px' }}>
          <h2>{SECTION_BUTTONS.find((btn) => btn.key === activeSection).label}</h2>
          <div style={{ display: 'flex', gap: '4px' }}>
            <button style={{ marginTop: '0', padding: '10px 12px' }} className="btn btn-sm btn-success" onClick={saveDetails}>Save & Next</button>
            <button style={{ marginTop: '0', padding: '10px 12px' }} className="btn btn-sm btn-success" onClick={onViewPortfolio}>View Portfolio</button>
          </div>
        </div>
        {renderSectionContent()}
      </div>
    </div>
  );
};

export default PortfolioForm;